import { render } from "./LayoutEmpty.vue?vue&type=template&id=33c696fe&scoped=true"
import script from "./LayoutEmpty.vue?vue&type=script&lang=js"
export * from "./LayoutEmpty.vue?vue&type=script&lang=js"

import "./LayoutEmpty.vue?vue&type=style&index=0&id=33c696fe&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c696fe"]])

export default __exports__